import React, { useState } from 'react';
import useInterval from 'react-useinterval';
import Loader from '../../../components/Loader';
import { getTrustStartStatus } from '../../../services/truststartService';
import Text from '../../../components/Text';

import styles from './FinicityConnect.module.scss';

const regularDelay = 2 * 1000;
const initialDelay = 2 * regularDelay;
const stopDelay = null;
const timeout = 2 * 60 * 1000;

const renderError = (errorMessage) => {
  if (!errorMessage) return null;
  return (
    <div className={styles.errorMessageWrapper}>
      <p>
        {errorMessage}
      </p>
    </div>
  );
};

export default function FinicityWaitForAggregationView(props) {
  const { requestId, onComplete, lastTimestamp } = props;
  const [delay, setDelay] = useState(initialDelay);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState();

  const expiresAt = Date.now() + timeout;

  const aggregationStatusResults = {
    Ok: (fixLink, timestamp) => onComplete(true, timestamp),
    Error: (fixLink, timestamp) => onComplete(false, fixLink, timestamp),
  };

  const handleError = (message) => {
    setLoading(false);
    setErrorMessage(message);
    setDelay(stopDelay);
  };

  useInterval(
    async () => {
      const response = await getTrustStartStatus(requestId, 'finicity', lastTimestamp);
      if (response?.statusCode === 404) {
        if (delay !== regularDelay) {
          setDelay(regularDelay);
        }
        if (expiresAt > Date.now()) return;
        handleError('A response from your bank was not received. Please contact your service provider for help.');
        return;
      }
      if (response?.statusCode === 200) {
        const { aggregationStatus, fixLink, timestamp } = JSON.parse(response.body);
        const handler = aggregationStatusResults[aggregationStatus];
        if (handler) {
          handler(fixLink, timestamp);
          return;
        }
      }
      handleError('An unexpected error occurred. Please contact your service provider for help.');
    },
    delay,
  );

  return (
    <>
      { loading && (
        <>
          <div data-cy="wait-for-status">
            <Text value="Please wait while we fetch your account details." />
          </div>
          <Loader />
        </>
      )}
      { renderError(errorMessage) }
    </>
  );
}
